export const AVAILABILITY_VALIDATION_MESSAGES = {
  endDateBeforeStart: "End Date must be greater than or equal to Start Date.",
  endTimeBeforeStart: "End Time must be greater than Start Time.",
};

export const isValidDateRange = (dateFrom, dateTo) => {
  if (!dateFrom || !dateTo) return true;
  return dateFrom <= dateTo;
};

export const isValidTimeRange = (timeFrom, timeTo) => {
  if (!timeFrom || !timeTo) return true;
  const from = String(timeFrom).slice(0, 5);
  const to = String(timeTo).slice(0, 5);
  return to > from;
};

export const getDateRangeError = (dateFrom, dateTo) =>
  isValidDateRange(dateFrom, dateTo) ? "" : AVAILABILITY_VALIDATION_MESSAGES.endDateBeforeStart;

export const getTimeRangeError = (timeFrom, timeTo) =>
  isValidTimeRange(timeFrom, timeTo) ? "" : AVAILABILITY_VALIDATION_MESSAGES.endTimeBeforeStart;
